import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import {
  ButtonLink,
  PrimaryButton,
  PrimaryButtonOutlined,
} from "@components/Button";
import Div from "@components/Div";
import { Error, H2 } from "@components/Heading";
import { InputOtp } from "@components/Input";
import { TextMediumWeight } from "@components/Text";

import { useOTPForm } from "./OTPForm.hooks";
import { OTP_LENGTH } from "./OTPForm.constants";

const OTPForm = ({ id, email, scope, onSubmit, onCancel, onError }) => {
  const { formatMessage, messages } = useIntl();
  const {
    errorMessage,
    formik,
    handleOtpChange,
    handleRequestOtpOnEmail,
    isLoading,
    isResendAvailable,
    resendLinkLabel,
  } = useOTPForm({ id, email, scope, onSubmit, onError });

  return (
    <Div
      display="flex"
      flexDirection="column"
      alignItems="center"
      p={3}
      gridGap={3}
    >
      <H2 color="var(--blue-dark) !important">{messages.title_enter_otp}</H2>

      <TextMediumWeight textAlign="center" width="90%">
        {email
          ? formatMessage(
              { id: "message_otp_code_description_with_email" },
              {
                email,
              }
            )
          : formatMessage({ id: "message_otp_code_description" })}
      </TextMediumWeight>

      <Div
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Div mb={3}>
          <InputOtp
            name="otp"
            numInputs={OTP_LENGTH}
            value={formik.values.otp}
            onChange={handleOtpChange}
          />
        </Div>

        {errorMessage !== "" && (
          <Error textAlign="center">{errorMessage}</Error>
        )}

        <ButtonLink
          label={resendLinkLabel}
          disabled={isLoading || !isResendAvailable}
          onClick={handleRequestOtpOnEmail}
        />
      </Div>

      <Div
        width={1}
        display="flex"
        flexDirection={["column-reverse", "column-reverse", "row", "row"]}
        alignItems="center"
        justifyContent="center"
        gridGap={3}
      >
        <PrimaryButtonOutlined
          width={[1, 1, "150px", "150px"]}
          height={40}
          label={messages.label_back}
          onClick={onCancel}
        />

        <PrimaryButton
          width={[1, 1, "150px", "150px"]}
          height={40}
          label={messages.login}
          disabled={isLoading || !formik.dirty || !formik.isValid}
          onClick={formik.handleSubmit}
        />
      </Div>
    </Div>
  );
};

OTPForm.propTypes = {
  id: PropTypes.string.isRequired,
  email: PropTypes.string,
  scope: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

export default OTPForm;
